<template>
  <div>
    <el-row><el-col :offset="20"><h3>退款金额：{{ totalRefund }}</h3></el-col></el-row>
    <el-table
      v-loading="listLoading"
      :key="0"
      :data="alist"
      border
      fit
      highlight-current-row
      style="width: 100%;"
    >
      <el-table-column label="会员ID" align="center" min-width="100px">
        <template slot-scope="scope">
          <span>{{ scope.row.memberId | memberIdFilter }}</span>
        </template>fetchTotalCharge
      </el-table-column>
      <el-table-column label="会员姓名" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.memberName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="账户类型" align="center" min-width="100px">
        <template slot-scope="scope">
          <span>{{ scope.row.memberType | accountTypeFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column label="会员卡号" align="center" min-width="100px">
        <template slot-scope="scope">
          <span>{{ scope.row.memberCardNo | cardFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column label="车牌号" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.memberCarNo | blankFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column label="退款金额" align="center" min-width="90px">
        <template slot-scope="scope">
          <span>{{ scope.row.amt }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作站点" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.optStationName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作员工" align="center" min-width="100px">
        <template slot-scope="scope">
          <span>{{ scope.row.optEmpName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="退款时间" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.createdTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="备注" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.memo | blankFilter }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'Charge',
  filters: {
    blankFilter (val) {
      if (!val && val !== 0 || val === 'null' || val === 'undefined') {
        return ''
      } else {
        return val
      }
    },
    cardFilter (val) {
      if (!val) {
        return '-'
      } else {
        return val
      }
    },
    memberIdFilter (memberId) {
      if (!memberId) {
        return '-'
      } else {
        return memberId
      }
    },
    accountTypeFilter (type) {
      switch (type) {
        case 1:
          return '散户'
        case 2:
          return '车队子账户'
        case 3:
          return '车队总账户'
        default:
          return ''
      }
    }
  },
  props: {
    alist: {
      type: Array,
      required: true,
      twoWay: true
    },
    listLoading: {
      type: Boolean,
      required: true,
      twoWay: true
    },
    totalRefund: {
      type: Number,
      required: true,
      twoWay: true
    }
  },
  created () {
  }
}
</script>

